// extracted by mini-css-extract-plugin
export default {"infoWrapper":"ActivityTab_infoWrapper__UXy40","itemList":"ActivityTab_itemList__-HcmI","item":"ActivityTab_item__hUtJX"};